import React, { useState } from 'react'
import { twMerge } from 'tailwind-merge'
import Icons from '@/assets/icons'

interface Input {
    id: string,
    label: string,
    type?: string,
    error?: string,
    containerClassProps?: string,
    [key: string]: any
}

const Input: React.FC<Input> = ({ id, label, type="text", error='', containerClassProps='', ...props }) => {
  const [togglePassword, setTogglePassword] = useState(true)
  // Classes para estilização do container input
  const SubContainerStyle = 'px-2 py-1 bg-neutro-50 rounded-sm border relative'

  // Função para lidar com o estado de erro do input (Aplica estilo no container)
  const SubContainerErrorState = (): string => {return error && !props.disabled ? "outline outline-erro-500" : ""}
  const SubContainerFinalStyle = twMerge(SubContainerStyle, 'w-full relative', SubContainerErrorState())

  // Classes para estilização do input
  const LabelDefaultStyle = 'block font-medium'
  
  // Função para lidar com o estado de erro do input (Aplica estilo no input)
  const LabelErrorState = (): string => { return error && !props.disabled ? "text-erro-500" : "" }
  const LabelDisabledStyle = (): string => { return props.disabled ? 'text-gray-500' : 'text-primario-700' }
  const LabelStyle = twMerge(LabelDefaultStyle, LabelDisabledStyle(), LabelErrorState())

  const TogglePasswordBtnStyle = 'cursor-pointer absolute right-4 top-1/2 transform -translate-y-1/2'

  return (
    <div className={containerClassProps}>
      <label className={LabelStyle} htmlFor={id}>{label}</label>
      <div className={SubContainerFinalStyle}>
          <input 
            className={`w-full py-1 outline-none bg-transparent ${props.disabled ? 'text-gray-500 cursor-not-allowed' : ''}`}
            id={id} 
            name={id} 
            type={togglePassword ? type : 'text'} 
            {...props}
          />
          { type === 'password' && (
            <button 
              className={TogglePasswordBtnStyle} 
              type='button' 
              onClick={() => setTogglePassword(!togglePassword)}
              disabled={props.disabled}
            >
              { togglePassword ? <Icons.EyeClosed /> : <Icons.EyeOpen /> }
            </button>
          ) }
      </div>
      {error && !props.disabled && <p className='text-erro-500 mt-1'>{error}</p>}
    </div>
  )
}

export default Input